import React, {useEffect, useState} from 'react';
import { useSelector , useDispatch} from 'react-redux';
import {
  Grid, Button, Stack, Box, Chip,
  Paper, Typography,IconButton, Tooltip, Collapse,
  InputLabel,Select, FormControl, FormHelperText, FormGroup, FormControlLabel, ListItem,
  MenuItem
} from '@mui/material';



import { useNavigate, useLocation, Outlet } from 'react-router-dom';

import {usePlayContext} from '../utils/PlayContext';

import {  selectAllApplications, 

          fetchAllApplications,
          refreshApplications,
          selectApplicationPeriod,
          selectApplicationStatus,
          selectAllSubjects} from '../store/applicationSlice' 


          

import ViewProvider from '../utils/ViewContext'



const InvitationPage = () => {

    const {
      setOp,
      status, setStatus, appTitle, setAppTitle, 
      errorMessage, setErrorMessage, errorTitle, setErrorTitle,
      setTenantLogo
    }=usePlayContext()

    const dispatch = useDispatch();
  
    const navigate = useNavigate()
    const dataStatus = useSelector(selectApplicationStatus)
    
    
    const doFetchInvitations = async ()=>{
      setStatus('processing')
      
      try
      {
        if ("succeeded"!==dataStatus)
        {
          let resp = await dispatch(refreshApplications()).unwrap();
        }
        else
        {
          let resp = await dispatch(fetchAllApplications()).unwrap();
        }

          
          setStatus('idle')
      }
      catch (ex)
      {
        setStatus('error')
        setErrorMessage("Unable to retrieve Invitations")
      } 
    }
    
    useEffect(() =>{
      //alert(dataStatus)
        doFetchInvitations()
    }, [])
  
    
  return (

  <ViewProvider>
    <Box sx={{ p:0, width:'100%' }}>
        <Outlet/>       
    </Box>
    </ViewProvider>  );
};

export default InvitationPage;
